<template>
  <div class="container-table">
    <div v-if="showTabulator"
      class="options-download row mb-2 col-md-12 justify-content-between align-items-center p-0">
      <div class="d-flex flex-grow-2">
        <b-button id="download-csv" pill size="sm" variant="secondary" class="m-1 align-items-center"
          @click="downloadCSV">
          <csv-icon style="font-size: 1.1em; vertical-align: -3%" />
          Baixar CSV
        </b-button>
        <b-button id="download-xlsx" @click="downloadXLSX" pill size="sm" variant="secondary" class="m-1">
          <excel-icon style="font-size: 1.1em; vertical-align: -3%" />
          Baixar XLSX
        </b-button>
        <b-button id="download-pdf" @click="downloadPDF" pill size="sm" variant="secondary" class="m-1">
          <pdf-icon style="font-size: 1.1em; vertical-align: -3%" />
          Baixar PDF
        </b-button>
      </div>
      <div class="total-events m-0 pl-3">Eventos registrados : {{ data.length }}</div>
    </div>
    <!-- BOTÃO DE ADICIONAR EVENTO -->
    <!-- <div class="row mb-2 col-md-12 justify-content-end p-0">
      <b-dropdown
        id="dropdown-right"
        right
        size="sm"
        :text="sortingText"
        variant="outline-secondary"
        class="mb-2 mr-0 mb-sm-0 align-self-center"
      >
        <b-dropdown-item @click="changeSortingAnotation('all')"
          >Todos</b-dropdown-item
        >
        <b-dropdown-item @click="changeSortingAnotation('notes')"
          >Com anotações</b-dropdown-item
        >
      </b-dropdown>
      <b-button
        id="download-pdf"
        @click="showFormEvent"
        size="sm"
        variant="success"
        class="m-1"
      >
        <pdf-icon style="font-size: 1.1em; vertical-align: -3%" />
        Adicionar evento
      </b-button>
    </div> -->
    <!-- <b-skeleton-table
      v-if="!showTabulator"
      :rows="5"
      :columns="2"
      :table-props="{ bordered: true, striped: true }"
    ></b-skeleton-table> -->
    <div ref="table" class="table" v-show="showTabulator"></div>
  </div>
</template>

<script>
import Tabulator from "tabulator-tables";
import moment from "moment";
export default {
  name: "tableEvents",
  props: {
    data: {
      type: Array,
      required: false,
      default: [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    chartMounted: Boolean,
  },
  data() {
    return {
      tabulator: null,
      tableData: [],
      isSortingNoteNull: true,
      sortingText: "Com anotações",
      showTabulator: false,
      limit: 60,
      columns: [
        {
          title: "Data",
          field: "NAME",
          sorter: "string",
          headerFilterLiveFilter: false,
          // headerFilter: "input",
          hozAlign: "center",
          resizable: false,
          formatter: "datetime",
          widthGrow: 1,
          variableHeight: true,
          formatterParams: {
            inputFormat: "YYYY-MM-DD HH:mm:ss",
            outputFormat: "DD/MM/YY - HH:mm:ss",
            invalidPlaceholder: "(Data inválida)",
          },
          headerFilter: this.minMaxFilterEditor
        },
        {
          title: "Anotação",
          field: "VALUE",
          sorter: "string",
          variableHeight: true,
          headerFilterPlaceholder: "Filtrar por nomes dos eventos...",
          hozAlign: "center",
          headerFilter: "input",
          widthGrow: 2,
          resizable: false,
          formatData: [],
          mutator: function (value, data, type, params, component) {
            if (value) {
              return value.replace(
                /[^a-z-A-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ()³²'\s ]/g,
                " "
              );
            }
          },
        },
      ],
    };
  },
  watch: {
    chartMounted() {
      setTimeout(() => {
        this.pages = Math.ceil(this.data.length / this.limit);
        this.tabulator.setData(this.data);
        this.showTabulator = true;
      }, 500);
    },
  },
  mounted() {
    window.moment = moment;

    this.tabulator = new Tabulator(this.$refs.table, {
      pagination: "local",
      data: [], //link data to table
      layout: "fitColumns",
      columns: this.columns,
      responsiveLayout: true,
      // virtualDomBuffer: 100,
      minHeight: "10%",
      autoResize: true,
      paginationSize: this.limit,
      maxHeight: "100%",
      locale: true,
      langs: {
        "pt-br": {
          pagination: {
            "first": "Primeira", //text for the first page button
            "first_title": "First Page", //tooltip text for the first page button
            "last": "Última página",
            "last_title": "Última página",
            "prev": "Anterior",
            "prev_title": "Página anterior",
            "next": "Próxima",
            "next_title": "Próxima página",
          }
        }
      },
      initialSort: [
        { column: "NAME", dir: "desc" }, //sort by this first
      ],
      downloadConfig: {
        columnHeaders: true, //do not include column headers in downloaded table
        columnGroups: true, //do not include column groups in column headers for downloaded table
        rowGroups: true, //do not include row groups in downloaded table
        columnCalcs: false, //do not include column calcs in downloaded table
        dataTree: false, //do not include data tree in downloaded table
      },
    });
  },
  methods: {
    formatterAnnotation(cell, formatterParams, onRendered) {
      return cell
        .getValue()
        .replace(/[^a-z-A-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ()³²'\s ]/g, " ");
    },
    minMaxFilterEditor(cell, onRendered, success, cancel, editorParams) {
      //cell - the cell component for the editable cell
      //onRendered - function to call when the editor has been rendered
      //success - function to call to pass the successfuly updated value to Tabulator
      //cancel - function to call to abort the edit and return to a normal cell
      //editorParams - params object passed into the editorParams column definition property
      var container = document.createElement("span");
      //create and style inputs
      var start = document.createElement("input");
      start.setAttribute("type", "date");
      start.setAttribute("placeholder", "Min");
      start.style.padding = "2px";
      start.style.width = "100%";
      start.style.border = "solid 1px #fafafa";
      start.style.backgroundColor = "#fafafa";
      start.style.boxSizing = "border-box";
      start.id = "dateTimeSelector";
      start.value = cell.getValue();
      const onChange = (e) => {
        // this.tabulator.element.querySelectorAll(".tabulator-col.tabulator-sortable")[0].style.height="74px"
        // this.tabulator.element.querySelectorAll(".tabulator-col.tabulator-sortable")[1].style.height="74px"
        // Apagar do registro de filtros do tabulagor (this.tabulator.getFilter())
        // todos os filtros criados com o field NAME (Filtros de data)
        this.clearFiltersTabulator("NAME");
        if (e.target.value) {
          cell
            .getColumn()
            .getTable()
            .addFilter(
              "NAME",
              "starts",
              moment(e.target.value).format("YYYY-MM-DD")
            );
        }
      };
      cell.getColumn().getTable().addFilter("NAME", "starts", "");
      start.addEventListener("change", onChange);
      start.addEventListener("blur", onChange);
      container.appendChild(start);
      return container;
    },
    clearFiltersTabulator(fieldName) {
      var allFilters = this.tabulator.getFilters();
      for (var filter = 0; filter < allFilters.length; filter += 1) {
        if (allFilters[filter]["field"] === fieldName) {
          this.tabulator.removeFilter(
            fieldName,
            allFilters[filter].type,
            allFilters[filter].value
          );
        }
      }
    },
    changeSortingAnotation(type) {
      this.tabulator
        .getColumn("NAME")
        ._column.element.querySelector("#dateTimeSelector").value = "";
      this.clearFiltersTabulator("NAME");
      if (type == "all") {
        this.clearFiltersTabulator("VALUE");
        this.sortingText = "Todos";
        return;
      }
      this.tabulator.setFilter("VALUE", "!=", "-----", { matchAll: true });
      this.sortingText = "Com anotações";
    },
    showFormEvent() {
      this.$emit("showForm");
    },
    downloadXLSX() {
      this.tabulator.download("xlsx", `Relatório-eventos.xlsx`, {
        sheetName: `Relatório-Eventos`,
      });
    },
    downloadCSV() {
      this.tabulator.download("csv", `Relatório-eventos.csv`, {
        bom: true,
      });
    },
    downloadPDF() {
      this.tabulator.download("pdf", `Relatório-eventos.pdf`, {
        documentProcessing: function (workbook) {
          workbook.Props = {
            Title: "Relatório",
            Subject: "3v3",
            CreatedDate: new Date(2017, 12, 19),
          };
          return workbook;
        },
      });

    },
  },
};
</script>

<style scoped>
.total-events {
  font-size: smaller;
}

.pagination-table {
  padding: 4px;
  margin-left: 4px;
  background-color: #f0f0f0;
  border-radius: 4px;
  cursor: context-menu;
  border: solid 1px #dedede;
}

.table2 {
  visibility: hidden;
  height: 0;
}

.container-table {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 5px;
  width: 100%;
  /* height: 100%; */
  padding-top: 0.5em;
  align-content: flex-end;
}

.container-table>>>.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  white-space: normal;
}

.container-table>>>.tabulator {
  font-family: "Arial", sans-serif;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  /* padding: 0 4px; */
}

.container-table>>>.tabulator {
  font-family: "Arial", sans-serif;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  /* padding: 0 4px; */
}

.container-table>>>.tabulator .tabulator-header {
  font-weight: normal;
  border-bottom: 1px solid;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.54);
}

.container-table>>>.tabulator .tabulator-header .tabulator-col {
  height: 75px;
  background-color: #e6e6e6;
  padding: 0 6px;
  font-size: 15px;
  text-align: center;
  font-weight: 600;
  border: none !important;
}

.container-table>>>.tabulator .tabulator-tableHolder {
  overflow: hidden;
}

.container-table>>>.tabulator-row {
  border-bottom: 1px solid;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  min-height: 48px;
  vertical-align: middle;
}

.container-table>>>.tabulator-row .tabulator-cell {
  padding: 16px 7px;
  vertical-align: middle;
}

.container-table>>>.tabulator-row .tabulator-cell:first-of-type,
.container-table>>>.tabulator .tabulator-header .tabulator-col:first-of-type {
  padding-left: 24px;
}

.container-table>>>.tabulator-row.tabulator-row-even {
  background-color: #f7f7f7;
}
</style>
